import { render, staticRenderFns } from "./CruiseDetailRoute.vue?vue&type=template&id=5775f6ce&scoped=true"
import script from "./CruiseDetailRoute.vue?vue&type=script&lang=js"
export * from "./CruiseDetailRoute.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailRoute.vue?vue&type=style&index=0&id=5775f6ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5775f6ce",
  null
  
)

export default component.exports